module.exports = "<prg-grouped-list [source]=\"((deviceEvents | async) | creator:creatorFilter | matchingSearchText:(searchText | async) | groupByCategory | sortBy:'name')\"></prg-grouped-list>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/list-by-type/list-by-type.component.html
// module id = 1552
// module chunks = 2